export const Overflows = {
  Dots: `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  FullDots: `
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
}
